export const BODY_HEIGHT = '100vh';
export const EXTRA_LARGE_WIDTH_PX = 1200;
export const HEADER_HEIGHT = '90px';
export const LARGE_WIDTH_PX = 992;
export const MAIN_HEIGHT = `calc(${BODY_HEIGHT} - ${HEADER_HEIGHT})`;
export const MEDIUM_WIDTH_PX = 768;
export const MOBILE_HEADER_HEIGHT = '70px';
export const MOBILE_MAIN_HEIGHT = `calc(${BODY_HEIGHT} - ${MOBILE_HEADER_HEIGHT})`;
export const SMALL_WIDTH_PX = 576;
